import axios from "axios"
import { CarUploadRow } from "./CarUploadPage"


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const CAR_IMPORT_VALIDATE_URL = `${API_URL}api/v1/definition/excel-upload/validate`
const CAR_UPLOAD_URL = `${API_URL}api/v1/definition/excel-upload/upload`

export function validateCarUpload(cars: CarUploadRow[]) {
  return axios.post(CAR_IMPORT_VALIDATE_URL, cars)
}

export function uploadCars(cars: CarUploadRow[]) {
  return axios.post(CAR_UPLOAD_URL, cars)
}


